import { AlertCircle, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { setTitle } from "@/hooks/useHeader.ts";
import { getTickets } from "@/api/getTickets.ts";
import TicketCard from "@/components/TicketCard.tsx";
import { Ticket } from "@/types/ticket.ts";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert.tsx";
import { useTranslation } from "@/i18n";

const Tickets = () => {
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState<Ticket[]>();
  const [error, setError] = useState<string>();
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(t("tickets.title"));
    (async () => {
      try {
        const response = await getTickets();
        setTickets(response.data.results);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e: unknown) {
        setError(t("tickets.fetchFailed"));
      }
      setLoading(false);
    })();
  }, [t]);

  return (
    <div className="mx-auto flex h-full max-w-md min-w-[30vw] flex-col gap-2">
      <div className="flex h-full w-full flex-col items-center gap-4 overflow-auto">
        {loading && <LoaderCircle className="size-6 animate-spin" />}
        {!loading && !tickets?.length && <div>{t("tickets.empty")}</div>}
        {!!error && (
          <Alert variant="destructive" className="mx-auto my-4 w-fit">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>{t("common.somethingWentWrong")}</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        {!!tickets?.length &&
          tickets.map((ticket) => (
            <TicketCard ticket={ticket} key={ticket.id} />
          ))}
      </div>
    </div>
  );
};

export default Tickets;
